import { useState, useCallback, useRef } from "react";
import { track } from "@/utils/mixpanel";

export const useStripeData = (withTrial = true, priceId, couponId) => {
    const isFirstFetch = useRef(true);
    const [stripeData, setStripeData] = useState(null);

    const fetchStripeData = useCallback(() => {
        if (!isFirstFetch.current || !priceId) {
            console.error("useStripeData", { isFirstFetch: isFirstFetch.current, priceId });
            return;
        }

        isFirstFetch.current = false;

        const url = new URL("/quiz/stripe/data", window.location.origin);
        url.searchParams.set("withTrial", withTrial);
        url.searchParams.set("priceId", priceId);
        url.searchParams.set("enableCustomPaymentMethods", "true");
        couponId && url.searchParams.set("couponId", couponId);

        fetch(url, {
            method: "GET",
        })
            .then(res => res.json())
            .then(data => {
                console.log("stripeData", data);
                track("stripe_session_start", {
                    customerId: data.customerId,
                    priceAmount: data.priceAmount,
                    pricePerMonth: data.pricePerMonth,
                    subscriptionId: data.subscriptionId,
                });
                setStripeData(data);
            })
            .catch(err => {
                console.error("Error fetching stripe data", err);
                track("stripe_session_start_error", {
                    error: err.message,
                });
            });
    }, [withTrial, priceId]);

    return { fetch: fetchStripeData, stripeData };
}


